import './AppHeader.styles.scss';
import React, { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@material-ui/core';

import logoImg from '../../assets/imgs/logo-white.png';
import HeaderLoggedOut from './HeaderLoggedOut';
import UesrContext from '../../contexts/user-context/UserProvider';
import HeaderLoggedIn from './HeaderLoggedIn';
import ToggleThemeBtn from '../toggle-theme-button/ToggleThemeBtn';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';
import pickBkgClass from '../../utils/pickBkgClass';

const AppHeader = () => {
	const { loggedIn } = useContext(UesrContext);
	const { themeName } = useContext(MyThemeContext);
	return (
		// <header className={`appHeader ${themeName}`}>
		<header className={`appHeader ${pickBkgClass(themeName, 'soft')}`}>
			<div className="mfaContainer">
				<div className="headerContent">
					<Link
						color="primary"
						className="homeLink"
						to="/home"
						component={RouterLink}
						style={{ textDecoration: 'none' }}
					>
						<img src={logoImg} alt="logo" />
						<span>Socialize</span>
					</Link>

					{loggedIn ? <HeaderLoggedIn /> : <HeaderLoggedOut />}
					<ToggleThemeBtn />
				</div>
			</div>
		</header>
	);
};

export default AppHeader;
